/**
 * Program 12.1 UX4 — Commercial deviations matrix UI.
 */
import React from 'react';
import { Table, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { CommercialDeviationRow } from './commercialDeviations';

const riskColor: Record<string, string> = {
  ACCEPT: 'green',
  CLARIFY: 'blue',
  DEVIATE: 'orange',
  HIGH_RISK: 'red',
};

export type EpcCommercialDeviationsMatrixProps = {
  rows: CommercialDeviationRow[];
};

export const EpcCommercialDeviationsMatrix: React.FC<EpcCommercialDeviationsMatrixProps> = ({
  rows,
}) => {
  const columns: ColumnsType<CommercialDeviationRow> = [
    { title: 'Clause', dataIndex: 'clause', width: 120 },
    { title: 'Client requirement', dataIndex: 'client_requirement' },
    { title: 'Bid position', dataIndex: 'bid_position' },
    { title: 'Deviation', dataIndex: 'deviation', ellipsis: true },
    {
      title: 'Risk',
      dataIndex: 'risk',
      width: 100,
      render: (r: string) => (r ? <Tag color={riskColor[r] || 'default'}>{r}</Tag> : '—'),
    },
    {
      title: 'Approved',
      dataIndex: 'approved',
      width: 90,
      render: (v: boolean) => (v ? <Tag color="green">Yes</Tag> : <Tag>Pending</Tag>),
    },
  ];

  if (!rows.length) {
    return <span style={{ color: '#888' }}>No commercial deviations recorded.</span>;
  }

  return (
    <Table
      rowKey="id"
      size="small"
      columns={columns}
      dataSource={rows}
      pagination={false}
      scroll={{ x: 800 }}
    />
  );
};

export default EpcCommercialDeviationsMatrix;
